import React from "react";
import "./ErrorBoundary.scss";
import {getContarError} from "./api/user";

export default class ErrorBoundary extends React.Component{
    constructor(){
        super();
        this.state={
            error:false
        }
    }

    static getDerivedStateFromError(error){
        return{error:true}
    } 

     componentDidCatch(error,errorInfo){
        getContarError('Boundary Error',error)
        console.log(error)
        console.log(errorInfo)
    } 

    render(){
        if(this.state.error){
            return(
                <div style={{flex:1,justifyContent:'center',alignItems:'center',marginTop:'10px',marginLeft:'30px'}}>
                    <h1>Error 500:</h1>
                    <h2>Estamos trabajando para solucionarlo.</h2>
                    <div className='error'></div>
                </div>
            )
        }
        return this.props.children
    }
}